function loadMoreProducts() {
	var products_on_page = $('[js-products-on-page]');
	var next_url = products_on_page.attr('data-next-url');
	$.ajax({
		type: 'GET',
		url: next_url,
		dataType: 'html',
		async: false,
	}).done(function(next_page) {
		const html = new DOMParser().parseFromString(next_page, 'text/html');
		const new_products = $(html).find('[js-products-on-page] .col-6');
		const new_url = $(html).find('[js-products-on-page]').attr('data-next-url');
		const new_pages_total = $(html).find('[js-products-on-page]').attr('data-total-pages');
		const new_page_current = $(html).find('[js-products-on-page]').attr('data-current-page');
		products_on_page.attr('data-next-url', new_url);
		products_on_page.attr('data-total-pages', new_pages_total);
		products_on_page.attr('data-current-page', new_page_current);
		products_on_page.append(new_products);
        setTimeout(() => {
      	  $('[js-button-view-more]').trigger('click');
        }, "2000");
	});
}

document.addEventListener('DOMContentLoaded', () => {
	$('body').on('click', '[js-button-view-more]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var pagesTotal = parseInt($('[js-products-on-page]').attr('data-total-pages'));
		var pageCurrent = parseInt($('[js-products-on-page]').attr('data-current-page'));
		$('[js-button-view-more] .c-load-more__spinner').removeClass('d-none');
		if (pageCurrent < pagesTotal) {
			loadMoreProducts();
		}else{
			$('[js-button-view-more]').addClass('d-none');
			$('[js-button-view-more] .c-load-more__spinner').addClass('d-none');
		}
	});
});